<div class="box">
  <div class="box-row header">
    <app-header-bar
      [title]="'software.platforms'"
      [backRoute]="'/software'"
    ></app-header-bar>
  </div>
  <div class="box-row content mt-2">
    <div class="row w-100">
      <app-datatable
        [dataSource]="dataSource"
        [columns]="columns"
        [identifier]="'software-platform'"
        [customActions]="customActions"
        (newEvent)="new()"
        (showEvent)="show($event.valueOf())"
      >
        <app-empty-table
          [icon]="'settings'"
          [emptyText]="'software.platforms_emptyText' | translate"
          [buttonText]="'createNew' | translate"
          (btnClick)="new()"
        >
        </app-empty-table>
      </app-datatable>
      <app-model-modal #EditModal (saveEvent)="onSave()">
        <app-software-platform-form
          #form
          (closeEvent)="onModalClose()"
          (loadingEvent)="onLoading($event.valueOf())"
        ></app-software-platform-form>
      </app-model-modal>
    </div>
  </div>
</div>
